import React from 'react';
import { Card, CardContent } from '../ui/card';
import { suplementoCatLabel, sexoLabel, objetivoLabel } from '../../lib/labels';

// UNA FICHA DEL CATÁLOGO DE SUPLEMENTOS: la tarjeta de la página del catálogo
// (/admin/supplements-catalog) y la del «Ver catálogo» de la ficha del cliente (20-10), que
// enseñan lo mismo. `claro` es para la ficha, que va en fondo blanco; los botones de editar y
// desactivar los pone la página del catálogo como `children`.
const SuplementoDelCatalogo = ({ it, claro = false, children }) => {
    const tono = claro
        ? { caja: 'bg-white border-[#E5E2DB] shadow-none', titulo: 'text-[#1C1B19]', dato: 'text-[#57544E]', inactivo: 'text-[#B91C1C]' }
        : { caja: 'bg-[#111] border-[#222]', titulo: 'text-white', dato: 'text-white/40', inactivo: 'text-red-400' };
    return (
        <Card className={`${tono.caja} ${it.activo === false ? 'opacity-50' : ''}`} data-testid={`sup-catalogo-${it.id}`}>
            <CardContent className="p-4 flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <p className={`${tono.titulo} font-medium`}>
                        {it.titulo} {it.activo === false && <span className={`${tono.inactivo} text-xs`}>(inactivo)</span>}
                    </p>
                    <p className={`${tono.dato} text-xs mt-0.5`}>{suplementoCatLabel(it.categoria)} · {sexoLabel(it.sexo)} · {objetivoLabel(it.objetivo)}</p>
                    <p className={`${tono.dato} text-xs mt-1`}>{[it.cuanto, it.cuando].filter(Boolean).join(' · ')}</p>
                </div>
                {children && <div className="flex gap-1 flex-shrink-0">{children}</div>}
            </CardContent>
        </Card>
    );
};

export default SuplementoDelCatalogo;
